// Sadly, didnt found any way to work-around "any" props.
// Getting parsed from Recharts Library.

import { FunctionComponent } from 'react';
import { CartesianViewBox } from 'recharts/types/util/types';

type FlameIconProps = {
  viewBox?: CartesianViewBox;
};

const FlameIcon: FunctionComponent<FlameIconProps> = ({ viewBox }) => {
  return (
    <svg x={viewBox?.x} y={viewBox?.y ? viewBox.y - 30 : 0}>
      <g>
        <g id="icon_fire" fill="#FF0000" fillRule="nonzero">
          <path
            d="M18.7599553,4.84866118 L12.7030015,0 L14.827455,7.61218286 L14.9488612,8.09008003 C15.0744505,8.60064028 15.2004636,9.16173915 15.3179596,9.75318857 C15.5303718,10.8224255 15.689829,11.8651157 15.7748628,12.8243311 C15.8194826,13.3276608 15.8424754,13.7974586 15.8424754,14.2265065 C15.8424754,16.2052579 14.7036066,17.4972519 13.0668073,17.4972519 L12.8858043,17.4922738 C11.2707153,17.4030178 10.0413114,16.1229818 9.95555695,14.417694 L9.952,14.3103461 L10.6406122,6.05242892 L5.5844958,12.059696 C2.00071925,16.3176483 0,21.7249976 0,27.4234122 C0,35.6423801 6.65796604,42.3003461 14.8769339,42.3003461 C23.0959017,42.3003461 29.7538678,35.6423801 29.7538678,27.4234122 C29.7538678,18.5868258 25.6224474,10.3421651 18.7599553,4.84866118 Z"
            id="glow"
            fillOpacity="0.278266533"
          ></path>
          <path
            d="M17.1894339,6.91659613 C17.1894339,6.91659613 18.3302672,11.0020128 18.3302672,14.3165961 C18.3302672,17.4924295 16.2490172,20.0670128 13.0731839,20.0670128 C9.8819339,20.0670128 7.4769339,17.4924295 7.4769339,14.3165961 L7.5231839,13.7615961 C4.40901723,17.4615961 2.54360056,22.2561795 2.54360056,27.4670128 C2.54360056,34.2811795 8.06276723,39.8003461 14.8769339,39.8003461 C21.6911006,39.8003461 27.2102672,34.2811795 27.2102672,27.4670128 C27.2102672,19.1574295 23.2173506,11.7420128 17.1894339,6.91659613 Z M14.4298506,35.1753461 C11.6856839,35.1753461 9.4656839,33.0170128 9.4656839,30.3345128 C9.4656839,27.8370128 11.0844339,26.0795128 13.7977672,25.5245128 C16.5265172,24.9695128 19.3477672,23.6590961 20.9202672,21.5470128 C21.5215172,23.5357628 21.8298506,25.6324295 21.8298506,27.7753461 C21.8298506,31.8607628 18.5152672,35.1753461 14.4298506,35.1753461 Z"
            id="flame"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default FlameIcon;
